import React, { ReactNode, useState } from "react";

import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";

import { SxProps, Theme } from "@mui/material/styles";

import ActionMenuItem from "./ActionMenuItem";

import { MenuItem } from "./types";

import { Menu } from "./styles";

interface ActionMenuProps<T> {
  menuId: string;
  mainIcon: ReactNode;
  actions: MenuItem<T>[];
  row?: T;
  sx?: SxProps<Theme>;
}

const ActionMenu = <T extends { id: string }>(props: ActionMenuProps<T>) => {
  const { mainIcon, menuId, actions, row, sx } = props;

  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const visibleActions = actions.filter(
    (action) => !action?.hidden || (row && !action.hidden(row)),
  );

  return (
    <>
      <Box>
        <IconButton
          data-testid="action-menu-button"
          onClick={handleClick}
          size="small"
          aria-label="table-actions"
          aria-controls={open ? menuId : undefined}
          aria-haspopup="true"
          aria-expanded={open ? "true" : undefined}
          sx={sx}
        >
          {mainIcon}
        </IconButton>
      </Box>
      <Menu
        anchorEl={anchorEl}
        id={menuId}
        open={open}
        onClose={handleClose}
        onClick={handleClose}
        transformOrigin={{ horizontal: "right", vertical: "top" }}
        anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
      >
        {visibleActions.map((action) => (
          <ActionMenuItem key={action.id} item={action} row={row} />
        ))}
      </Menu>
    </>
  );
};

export default ActionMenu;
